'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';

import Image from '@eliadmin/core/src/components/image/image-wrapped';

import type { ProductDetailData } from '@eliadmin/core/src/api/products/types/product-types';

import { LightboxComponent } from '@eliadmin/core/src/components/lightbox/lightbox-component';
import { useDisclosure } from '@eliadmin/core/src/hooks/use-disclosure';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useState } from 'react';

export const ProductGallery = ({ product }: { product: ProductDetailData }) => {
  const { isOpen, setIsOpen } = useDisclosure(false);
  const [imagesSorted, setImagesSorted] = useState<{ url: string; name: string }[]>([]);

  const handleOpenGallery = (images: any, index: number) => () => {
    if (Array.isArray(images) && index >= 0 && index < images.length) {
      const newImages = [...images.slice(index), ...images.slice(0, index)];
      setImagesSorted(newImages);
      setIsOpen(true);
    } else if (images && !Array.isArray(images)) {
      setImagesSorted([images]);
      setIsOpen(true);
    }
  };

  return (
    <>
      <LightboxComponent isOpen={isOpen} setIsOpen={setIsOpen} images={imagesSorted} />
      <div className="hide-scroll-bar flex w-full grid-cols-12 flex-nowrap items-start justify-start gap-x-2 gap-y-4 overflow-scroll sm:gap-x-4 md:grid md:gap-y-6 md:overflow-hidden">
        {product.images?.map((image, index) => {
          // const isFifth = index % 5 === 4;
          const isFourth = index % 4 === 3;

          return (
            <button
              type="button"
              key={index}
              onClick={handleOpenGallery(product.images, index)}
              className={cn(
                'relative w-full cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary',
                isFourth
                  ? 'col-span-12 h-[155px] min-w-[125px] sm:h-[600px] lg:h-[800px]'
                  : 'col-span-6 h-[155px] min-w-[125px] sm:h-[215px] xl:col-span-4 xl:h-[300px] 2xl:h-[360px]',
              )}
            >
              <Image
                src={image.url}
                alt={resolveImageAlt(image, product?.name)}
                fill
                style={{ objectFit: 'cover', objectPosition: 'center' }}
                sizes={
                  isFourth
                    ? '(max-width: 767px) 125px, (max-width: 1535px) 55vw, 900px'
                    : '(max-width: 767px) 125px, (max-width: 1279px) 28vw, (max-width: 1535px) 19vw, 300px'
                }
                loading="lazy"
              />
            </button>
          );
        })}
      </div>
    </>
  );
};
